import { Link } from 'react-router-dom';

import { isFirefox } from 'helpers/is';
import Icon from 'components/Icon';

const HeaderSubMenuLink = ({
  onClick,
  title,
  text,
  to,
  icon,
  first = false,
  last = false,
}) => {
  const handleDragStart = e => isFirefox && e.preventDefault();

  return (
    <li
      className={cx('submenu__item', {
        submenu__item_first: first,
        submenu__item_last: last,
      })}
      onDragStart={handleDragStart}
    >
      <Link
        to={to}
        className={cx('submenu__link', {
          submenu__link_first: first,
          submenu__link_last: last,
        })}
        onClick={onClick}
        draggable={false}
      >
        <Icon icon={icon} className="submenu__icon" />
        <div className="submenu__desc">
          <div className="submenu__title">{title}</div>
          <div className="submenu__text">{text}</div>
        </div>
      </Link>
    </li>
  );
};
export default HeaderSubMenuLink;
